module.exports = __webpack_public_path__ + "img/icon_jd.5a84d9d9.png";